import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { fakeTableList, schema } from "./parts";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { useContext, useEffect, useRef } from "react";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import _ from "lodash";
import { TkRouteContext } from "../../context/tkRouteContext";

/**
 * SCRC070007 登録方法選択
 * @returns SCRC070007 登録方法選択
 */
const SCRC070007 = () => {
  const navigate = useNavigate();
  const { state: businessState } = useContext(BusinessContext);
  const { state, setState } = useContext(GlobalContext);

  const location = useLocation();
  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const wantToSetInRouterList = useRef<any>(
    location.state?.wantToSetInRouterList ?? []
  );

  useEffect(() => {
    if (wantToSetInRouterList.current.length === 0) {
      return;
    }
    if (_.isEqual(wantToSetInRouterList.current, routerState.routerList)) {
      return;
    }
    setRouterState({
      routerList: wantToSetInRouterList.current as any,
    });
  }, [wantToSetInRouterList, routerState.routerList, setRouterState]);

  const onCheckAndSubmit = (data: any) => {
    if (data.registerMethod === "1") {
      if (businessState.common?.businessType === "JOB-23") {
        navigate("/SCRC060108");
      } else if (businessState.common?.businessType === "JOB-25") {
        navigate("/SCRC060112");
      } else if (businessState.common?.businessType === "JOB-26") {
        navigate("/SCRC060116");
      } else if (businessState.common?.businessType === "JOB-27") {
        navigate("/SCRC060103");
      } else if (businessState.common?.businessType === "JOB-32") {
        navigate("/SCRC060118");
      } else if (businessState.common?.businessType === "JOB-10") {
        navigate("/SCRC060112");
      }
    } else {
      navigate("/SCRC100001");
    }
  };

  useEffect(() => {
    setState({
      ...state,
      errorMsgId: "",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="SCRC070007" data-testid="SCRC070007PageForTest">
      <TkInfoManual>{labelids.labelid.LBLC070007_01}</TkInfoManual>
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC070007_02}</TkInfoManual>
      <TkFakeTable
        list={fakeTableList}
        ruleSchema={schema}
        buttonGroup={<TkBackButton />}
        submitButtonText="次へ"
        onCheckAndSubmit={(data: any) => onCheckAndSubmit(data)}
      />
    </Box>
  );
};

export default SCRC070007;
